export const getTextWidth = (text: string, font: string): number => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return 0;
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
};

export const formatNumberToString = (num: number): string => {
  // Check if the number is an integer
  if (Number.isInteger(num)) {
    return num.toString(); // Convert integers directly to string
  }
  return num.toFixed(2); // Convert non-integers to string with 2 decimal places
};
